import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import TermAttendanceStatusService from "../../../Services/TermAttendanceStatus.service";
const makeSearchArgs = {
    loadOptions: (search, options) => TermAttendanceStatusService.search(Object.assign(Object.assign({}, options), { name: search })).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const TermAttendanceStatusSearch = makeSearch(makeSearchArgs);
export const TermAttendanceStatusMultiSearch = makeMultiSearch(makeSearchArgs);
